import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    city: 'City (optional)',
    country: 'Country (optional)',
    email: 'Email address',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Phone number (optional)',
    street: 'Address (optional)',
    zip: 'Zip (optional)',
  },

  fr: {
    city: 'Ville (facultatif)',
    country: 'Pays (facultatif)',
    email: 'Adresse e-mail',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    phone: 'Numéro de téléphone (facultatif)',
    street: 'Adresse (facultatif)',
    zip: 'Code postal (facultatif)',
  },
});

export default locales;
